import _ from 'lodash';

export const initial = (firstName, lastName) => {
  return `${firstName?.charAt(0).toUpperCase() || ''}${lastName?.charAt(0).toUpperCase() || ''}`;
};

export const maskEmail = (email) => {
  return email?.replace(/(.{3})(.*)(?=@)/, (gp1, gp2, gp3) => `${gp2}${'*'.repeat(gp3.length)}`);
};

export const roleTextCaseConverter = (role) => {
  if (!role) {
    return '';
  }
  const array = role.split('_');
  if (array.length > 1) {
    return `${array[0]} ${_.startCase(array[1].toLowerCase())}`;
  }

  return _.startCase(role.toLowerCase());
};

export const permissionStartCaseConverter = (permission) => {
  return _.startCase(permission.replace(/_/g, ' '));
};

export const ispRoleTextConverter = (role) => {
  const roleText = role.replace('ISP_', '');
  return _.startCase(roleText.toLowerCase());
};
